"use strict";Object.defineProperty(exports, "__esModule", {value: true});// index.ts
var _rectanglegrid = require('@turf/rectangle-grid');
function squareGrid(bbox, cellSide, options = {}) {
  return _rectanglegrid.rectangleGrid.call(void 0, bbox, cellSide, cellSide, options);
}
var turf_square_grid_default = squareGrid;



exports.default = turf_square_grid_default; exports.squareGrid = squareGrid;
//# sourceMappingURL=index.cjs.map